module.exports = __webpack_public_path__ + "img/boy selection.8508dbb0.png";